<template>
  <div>
    <div class="gr-section-wrapper gr-section-wrapper-lg-row" style="height: 100%" :style="paddingTop">
      <div class="gr-content-container" :style="sectionHeight">
        <div class="gr-text-container gr-text-container-lg-column px-4">
          <transition name="slide-fade" appear>
            <div>
              <h1 class="gr-header-2">Unsere Schmuckstücke</h1>
              <div class="gr-p-container">
                <p>
                  <b>Wählen Sie eine der unten stehenden Galerien aus </b> um sich hier eine Auswahl unserer Schmuckstücke
                  anzusehen. Vom Entwurf bis zum letzten Schliff werden die Stücke in unserer Werkstatt handgefertigt.</p>
              </div>
              <div class="btn-container" v-reveal>
                <button class="gr-category-btn" @click="$routePush('schmuckstuecke/ringe')">
                  <img class="gr-category-img" src="@/assets/imgs/ringe_btn.jpg" alt="Handgefertigte Ringe – Galerie ansehen" loading="lazy" decoding="async">
                  <h3>Ringe</h3>
                  <div class="gr-category-hover-text" aria-hidden="true">ansehen</div>
                </button>
                <button class="gr-category-btn" @click="$routePush('schmuckstuecke/ohrringe')">
                  <img class="gr-category-img" src="@/assets/imgs/ohrringe_btn.jpg" alt="Handgefertigte Ohrringe – Galerie ansehen" loading="lazy" decoding="async">
                  <h3>Ohrringe</h3>
                  <div class="gr-category-hover-text" aria-hidden="true">ansehen</div>
                </button>
                <button class="gr-category-btn" @click="$routePush('schmuckstuecke/ketten')">
                  <img class="gr-category-img" src="@/assets/imgs/ketten_btn.jpg" alt="Goldketten – Galerie ansehen" loading="lazy" decoding="async">
                  <h3>Ketten</h3>
                  <div class="gr-category-hover-text" aria-hidden="true">ansehen</div>
                </button>
                <button class="gr-category-btn" @click="$routePush('schmuckstuecke/armschmuck')">
                  <img class="gr-category-img" src="@/assets/imgs/armschmuck_btn.jpg" alt="Armschmuck – Galerie ansehen" loading="lazy" decoding="async">
                  <h3>Armschmuck</h3>
                  <div class="gr-category-hover-text" aria-hidden="true">ansehen</div>
                </button>
                <button class="gr-category-btn" @click="$routePush('schmuckstuecke/manschettenknoepfe')">
                  <img class="gr-category-img" src="@/assets/imgs/manschetten_btn.jpg" alt="Manschettenknöpfe – Galerie ansehen" loading="lazy" decoding="async">
                  <h3>Manschettenknöpfe</h3>
                  <div class="gr-category-hover-text" aria-hidden="true">ansehen</div>
                </button>
              </div>
              <gr-btn-lite text="zurück" backgroundColor="turquise" @click.native="$routeBack()"></gr-btn-lite>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="section fp-auto-height">
      <AppFooter backgroundColor="tourquise"></AppFooter>
    </div>
</div>
</template>

<script>

import AppFooter from './../../layout/Footer'
import grBtnLite from '@/components/grBtnLite'

export default {
  name: 'Goldschmiede',

  components: {
    grBtnLite,
    AppFooter
  },
  data () {
    return {
      isNewLoading: true,
      isImageLoading1: true,
      imgContainerHeight: 0,
      textContainerHeight: 0,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('setHeader', true)
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.isNewLoading = true
    // make sure loading is set to true
    this.setLoading(true)
  },
  mounted () {
    document.body.style.height = 'auto'
    this.handleResize()
    this.isImageLoading1 = false
  },
  beforeMount () {
    this.isNewLoading = false
    setTimeout(() => this.setLoading(false), 1000)
  },
  computed: {
    paddingTop () {
      if (this.isDesktop) {
        return { padding: '50px 0 0 0 !important' }
      } else {
        return { padding: Math.round(this.$store.getters['dom/navBarHeight'] + 15) + 'px 0 30px 0 !important' }
      }
    },
    isDesktop: function () {
      return this.$store.getters['dom/isDesktop']
    },
    isLoading: function () {
      return !this.$store.getters['loading/isLoadingApp']
    },
    sectionHeight () {
      return this.isDesktop && { 'min-height': Math.round(this.window.height - Math.min(65, this.$store.getters['dom/navBarHeight'])) + 'px !important' }
    }
  },
  methods: {
    imageDownloadFinished (id) {
      this.isImageLoading1 = false
      setTimeout(() => {
        this.setLoading(false)
      }, 1)
    },
    setLoading (isLoaded) {
      if ((this.isImageLoading1 && this.isNewLoading) ||
          (!this.isImageLoading1 && !this.isNewLoading)) {
        this.$store.commit('loading/SET_LOADING_APP', isLoaded)
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      if (this.window.width < 992) {
        this.imgContainerHeight = this.window.height * 0.35
        this.textContainerHeight = (this.window.height - 80) * 0.65
      } else {
        this.imgContainerHeight = this.window.height * 0.40
        this.textContainerHeight = (this.window.height - 110) * 0.60
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-bottom: 10px;
  }
  b {
    font-weight: 500;
  }
  p {
    font-size: 0.95em;
    line-height: 1.7;
  }
  h3 {
    font-family: $font-content;
    font-size: 1em;
    line-height: 1.7;
    margin-bottom: 0 !important;
    font-weight: 500;
    letter-spacing: 0.05em;
  }
  .gr-section-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    background-color: $color-gr-rose;
  }
  .gr-text-container {
    line-height: 1.1;
  }
  .gr-p-container {
    margin-bottom: 0.5rem;
  }
  @media(min-width: 760px) {
    .gr-text-container-lg-column {
      max-width: 80vw;
      // prevent that on transition potential image below text-container moves
      min-height: 25vh;
    }
    .gr-p-container {
      margin-bottom: 1rem;
    }
  }
  @media(min-width: 760px) and (max-width: 1025px) {
    .gr-text-container {
      max-width: 80vw !important;
    }
  }
  @media(min-width: $window-lg) {
    .gr-scrollable {
      max-height: 100vh;
    }
    .gr-text-container-lg-column {
    }
    .gr-section-wrapper-lg-row {
      flex-direction: row;
      justify-content: flex-start;
    }
    p {
      font-size: 1.1em;
    }
    h3 {
      font-size: 1.1em;
    }
  }
</style>
